<template>
  <div class="password_setting">
    <template v-if="!accountInfo.hasCertify">
      <div class="setting_item">
        <van-field v-model.trim="reqData.certPhone" placeholder="手机号码" :border="false" />
      </div>
      <div class="setting_item">
        <van-field v-model.trim="reqData.certName" placeholder="姓名" :border="false" />
      </div>
      <div class="setting_item">
        <van-field v-model.trim="reqData.certNo" placeholder="身份证号" :border="false" />
      </div>
      <div v-if="qrcode" style="text-align: center">
        <img :src="qrcode" style="width: 60vw; height: 60vw" />
        <p style="margin-top: 3.2vw">截图保存后，支付宝扫码验证！</p>
      </div>
      <div class="btn_wrapper">
        <van-button
          v-if="!vertifyRes.certifyUrl"
          round
          type="info"
          size="normal"
          color="#F93244"
          @click="handleVertify"
          :disabled="!reqData.certNo || !reqData.certName || !reqData.certPhone"
          :loading="step1Loading"
          loading-text="认证中..."
          class="update_btn"
          >认证
        </van-button>
        <van-button
          v-else
          round
          type="info"
          size="normal"
          color="#F93244"
          @click="confirmFaceVertify"
          :loading="step2Loading"
          loading-text="检测中..."
          class="update_btn"
          >我已识别完成
        </van-button>
      </div>
    </template>
    <template v-else>
      <div style="padding: 3.2vw; display: flex; flex-direction: column; gap: 12px; align-items: center">
        <span style="color: green">已认证</span>
        <p>{{ accountInfo.certName }}-{{ accountInfo.certPhone }}</p>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { confrimFaceSuccess, certifyPersonInfo } from "@/api";
import QRCode from "qrcode";
export default {
  data() {
    return {
      accountInfo: this.account(),
      step1Loading: false,
      step2Loading: false,
      vertifyRes: {},
      qrcode: "",
      reqData: {
        certNo: "",
        certName: "",
        certPhone: this.account().mobile,
      },
    };
  },
  mounted() {
    const temp = JSON.parse(sessionStorage.getItem("vertifyData") || "false");
    if (temp) {
      this.vertifyRes = temp.vertifyRes || {};
      this.qrcode = temp.qrcode || "";
      this.reqData = temp.reqData || {
        certNo: "",
        certName: "",
        certPhone: this.account().mobile,
      };
    }
  },
  beforeDestroy() {
    sessionStorage.setItem(
      "vertifyData",
      JSON.stringify({
        qrcode: this.qrcode,
        reqData: this.reqData,
        vertifyRes: this.vertifyRes,
      })
    );
  },
  methods: {
    ...mapGetters(["account"]),
    ...mapActions(["GetAccount"]),
    async handleVertify() {
      this.step1Loading = true;
      certifyPersonInfo(this.reqData).then((res) => {
        this.step1Loading = false;
        console.log("[validateFields res] ---> ", res);
        if (res.success) {
          if (res.data.hasCertify) {
            this.$toast.success("验证完成");
            this.GetAccount();
          } else {
            this.vertifyRes = res.data;
            // window.open(this.vertifyRes.certifyUrl);
            QRCode.toDataURL(this.vertifyRes.certifyUrl).then((e) => {
              console.log("[e] ---> ", e);
              this.qrcode = e;
            });
          }
        } else {
          this.$toast.fail(res.msg);
        }
      });
    },
    async confirmFaceVertify() {
      this.step2Loading = true;
      const res = await confrimFaceSuccess(this.vertifyRes);
      this.step2Loading = false;
      console.log("[res] ---> ", res);
      if (res.data) {
        this.$toast.success("验证完成");
      } else {
        this.$toast.fail("未检测到人脸识别成功！");
      }
    },
  },
};
</script>

<style lang="less" scoped>
.password_setting {
  background-color: #f7f8fa;
  min-height: 100vh;
  padding-top: 3.2vw;
  .setting_item {
    height: 14.933vw;
    margin-bottom: 3.2vw;
    .code {
      font-size: 4.533vw;
      color: #f93244;
      height: 4.533vw;
      display: inline-block;
    }
    .code2 {
      font-size: 4.533vw;
      color: rgba(0, 0, 0, 0.45);
    }
  }
  .btn_wrapper {
    display: flex;
    justify-content: center;
    .update_btn {
      margin-top: 3.2vw;
      width: 91.467vw;
      height: 11.733vw;
    }
  }
}
/deep/ .van-cell {
  height: 14.933vw;
  display: flex;

  align-items: center;
}
/deep/ .van-field__control {
  font-size: 4.533vw;
}
</style>
